import dynamic from 'next/dynamic';
import { TravelAgentProps } from './TravelAgent.types';

export const TravelAgent = dynamic<TravelAgentProps>(() => import('./TravelAgent'));
